import React, { Component } from 'react'
import SharedRoomComponent from './SharedRoomComponent';
import withAppShell from '../../../hoc/withAppShell/WithAppShell';
import { SchoolInformationActions } from "../../../../store"
import lodashUtil from 'lodash';
import { connect } from "react-redux";
import { toast } from 'react-toastify';
import * as StringReplacer from '../../../../i18n/StringReplacer'
import { rulesUtil } from '../rules/dialog'
import { saveSchoolConcurrently } from '../../../../utils/ConcurrentSchoolSaveUtil';
export class SharedRoomContainer extends Component {

  constructor(props) {
    super(props);
    let room = {
      name: undefined,
      roomCount: 1,
      roomCode: "",
      weeklyAvailability: {
        availableForAllHours: 'true'
      }
    }

    this.state = {
      toggleChange: false,
      roomList: [],
      room: room,
      isScheduleOpen: false,
      showAddNewSharedRoomComponent: false,
      deletedRoomArray: [],
      modifiedRoomArray: [],
      confirmDialogSharedRoom: {
        isChanged: false
      },
      isSaved: false
    }
  }
  componentWillMount() {
    const i18n = this.props.i18n
    if (this.props.activeSchool.school_master === undefined) {
      toast(i18n.toastMsgs.noDataInSchoolIndormationMsg)
      this.props.previousStep()
    }
    else if (this.props.activeSchool.school_master.gradeLevels.length === 0) {
      toast(i18n.toastMsgs.noDataInGradeMsg)
      this.props.previousStep(false)
    }

    else {
      let roomList = []
      if (!lodashUtil.isEmpty(this.props.activeSchool.school_master.sharedRooms)) {
        if (this.props.activeSchool.school_master.sharedRooms.length > 0) {
          roomList = this.props.activeSchool.school_master.sharedRooms
        }
      }
      this.setState({
        roomList: JSON.parse(JSON.stringify(roomList))
      })
    }
  }
  onClickOfSave = async () => {
    const i18n = this.props.i18n
    let repeactSubjectName = false;
    let roomList = this.state.roomList
    let isSubjectNameEmpty = lodashUtil.find(roomList, { "name": "" });
    if (isSubjectNameEmpty != undefined) {
      toast(i18n.subjects.subjectNameIsEmpty);
    } else {
      for (let i = 0; i < roomList.length - 1; i++) {
        for (let j = i + 1; j < roomList.length; j++) {
          if (roomList[i].name === roomList[j].name) {
            repeactSubjectName = true;
            toast(`${roomList[j].name} ${i18n.subjects.repeatingSubjectName}`);
            break;
          }
        }

      }
      if (repeactSubjectName === false) {
        let tempActiveSchool = JSON.parse(JSON.stringify(this.props.activeSchool))
        let schedule_constraints = tempActiveSchool.schedule_constraints
        if (schedule_constraints != undefined && schedule_constraints.length > 0) {
          this.modifyingRoomObjectInRules(schedule_constraints);
        }
        tempActiveSchool.school_master.sharedRooms = roomList
        tempActiveSchool.school_master.modifiedDate = new Date()
        // await this.props.editSchoolInformation(this.props.userInformation._id, this.props.activeSchool._id, tempActiveSchool)
        //toast(i18n.requiredSharedRoom.sahredRoomSave)

        // let result = await saveSchoolConcurrently(this.props.editSchoolInformation,
        //   this.props.userInformation._id,
        //   this.props.activeSchool._id, 
        //   tempActiveSchool,
        //   i18n.toastMsgs.sahredRoomSave);
        let result = await saveSchoolConcurrently(this.props.editSchoolInformation,
          this.props.userInformation._id,
          this.props.activeSchool._id,
          tempActiveSchool,
          i18n.requiredSharedRoom.sahredRoomSave);
        this.setState({
          deletedRoomArray: [],
          modifiedRoomArray: [],
          confirmDialogSharedRoom: {
            isChanged: false
          }
        })

      }
    }

  }
  onClickOfAddNewSharedRoom = () => {
    return {};
  }
  addNewSharedRoom = () => {
    let room = {
      name: undefined,
      roomCount: 1,
      roomCode: "",
      weeklyAvailability: {
        availableForAllHours: "true"
      }
    }
    this.setState({ showAddNewSharedRoomComponent: true, room: room })
  }
  cancelAddNewSharedRoom = () => {
    this.setState({
      showAddNewSharedRoomComponent: false, room: {
        name: undefined,
        roomCount: undefined,
        roomCode: "",
        weeklyAvailability: {
          availableForAllHours: "true"
        }
      },
    })
  }



  AddNewSharedRoom = () => {
    this.setState({ showAddNewSharedRoomComponent: true })
  }


  addRow = (room) => {
    let roomList
    const i18n = this.props.i18n
    if (this.props.roomList !== undefined) {
      roomList = this.props.roomList
    } else {
      roomList = this.state.roomList;
    }
    let repeactRoomName = false;
    if (room.name === undefined) {
      toast(i18n.sharedRooms.roomNameIsEmpty);
    } else {

      let x = lodashUtil.find(roomList, ["name", room.name])
      if (x !== undefined) {
        repeactRoomName = true;
        let toastMessage = StringReplacer.getFormatedMessage(i18n.sharedRooms.repeatingRoomName,
          {
            RoomName: room.name
          })
        toast(toastMessage);
      }
      if (repeactRoomName === false) {
        roomList.push(room)
        this.setState({
          roomList: roomList,
          toggleChange: !this.state.toggleChange,
        })
        this.cancelAddNewSharedRoom()
      }
    }
  }

  showContextualHelp = (props, event) => {
    let content = props.contextualHelp["sharedRooms"];
    if (content !== undefined) {
      props.toggleDrawer("right", true, content)(event)
    }
  }

  getParticularAttributes = (roomObj) => {
    //Weired syntax havent understood it but, really appriciate it.
    let tempObj = (({ name, roomCode, _id }) => ({ name, roomCode, _id }))(roomObj);
    return tempObj
  }

  deletedRoomObject = (roomObj) => {
    let deletedRoomArray = JSON.parse(JSON.stringify(this.state.deletedRoomArray));
    let tempObj = this.getParticularAttributes(roomObj)
    deletedRoomArray.push(tempObj);
    this.setState({
      deletedRoomArray: deletedRoomArray
    })
  }


  roomObjectChanged = (changedObj, oldObj) => {
    let modifiedRoomArray = JSON.parse(JSON.stringify(this.state.modifiedRoomArray));

    if (changedObj.name !== oldObj.name) {
      let tempObj = this.getParticularAttributes(changedObj)
      modifiedRoomArray.push(tempObj);
    }
    this.setState({
      modifiedRoomArray: modifiedRoomArray
    })
  }

  modifyingRoomObjectInRules = (schedule_constraints) => {
    let deletedRoomArray = this.state.deletedRoomArray;
    let modifiedRoomArray = this.state.modifiedRoomArray;
    for (let i = 0; i < schedule_constraints.length; i++) {
      let scheduleConstraintObj = schedule_constraints[i];
      let sharedRoomsForSubjectsArray = scheduleConstraintObj.sharedRoomsForSubjects;
      let sharedRoomsForElectivesArray = scheduleConstraintObj.sharedRoomsForElectives;

      //SUBJECTS
      if (sharedRoomsForSubjectsArray.length > 0) {
        //ROOM DELETED
        if (deletedRoomArray.length > 0) {
          this.deletingRuleObject(deletedRoomArray, sharedRoomsForSubjectsArray, "subject", scheduleConstraintObj)
        }
        //ROOM MODIFIED
        if (modifiedRoomArray.length > 0) {
          this.replacingRoomObject(modifiedRoomArray, sharedRoomsForSubjectsArray, scheduleConstraintObj)
        }
      }

      // ELECTIVES
      if (sharedRoomsForElectivesArray.length > 0) {
        //ROOM DELETED
        if (deletedRoomArray.length > 0) {
          for (let x = 0; x < sharedRoomsForElectivesArray.length; x++) {
            let electiveObj = sharedRoomsForElectivesArray[x]
            let electiveToBeRemoved = this.deletingRuleObject(deletedRoomArray, electiveObj.subjects, "elective", scheduleConstraintObj)
            if (electiveToBeRemoved === true) {
              if (scheduleConstraintObj.status !== 'Completed') {
                sharedRoomsForElectivesArray.splice(x, 1)
                x -= 1;
                scheduleConstraintObj.isScheduleUpdated = true
              }
            } else {
              sharedRoomsForElectivesArray[x].isDirty = true;
              scheduleConstraintObj.isScheduleUpdated = true;
            }
          }
        }
        // ROOM MODIFIED
        if (modifiedRoomArray.length > 0) {
          for (let y = 0; y < sharedRoomsForElectivesArray.length; y++) {
            let electiveObj = sharedRoomsForElectivesArray[y]
            this.replacingRoomObject(modifiedRoomArray, electiveObj.subjects, scheduleConstraintObj)
          }
        }
      }
      if (scheduleConstraintObj.isSCheduleUpdated !== undefined && scheduleConstraintObj.isSCheduleUpdated === true) {
        scheduleConstraintObj.version = scheduleConstraintObj.version + 1
      }
    }
  }

  /**
   * this method takes the deleted objects array and 
   * the subjects array in which we have to check if the deleted room is present
   */
  deletingRuleObject = (deletedRoomArray, subjectRuleArray, type, scheduleConstraintObj) => {
    let electiveToBeRemoved = true;
    for (let a = 0; a < subjectRuleArray.length; a++) {
      let subjectObj = subjectRuleArray[a]

      // Subjects has "ROOM" and Electives has "ROOMS" in schema.
      let rooms = subjectObj.room !== undefined ? subjectObj.room : subjectObj.rooms
      for (let b = 0; b < rooms.length; b++) {
        let roomObj = rooms[b];
        let roomId = roomObj.roomId
        let isRoomPresent = lodashUtil.find(deletedRoomArray, ["_id", roomId])
        if (isRoomPresent != undefined) {
          if (scheduleConstraintObj.status !== 'Completed') {
            rooms.splice(b, 1);
            b -= 1
            scheduleConstraintObj.isScheduleUpdated = true;
          } else {
            rooms[b].isDirty = true;
            scheduleConstraintObj.isScheduleUpdated = true;
          }
        }
        if (b === rooms.length - 1) {
          if (type === "subject") {
            if (rooms.length === 0) {
              if (scheduleConstraintObj.status !== 'Completed') {
                subjectRuleArray.splice(a, 1)
                a -= 1;
                scheduleConstraintObj.isScheduleUpdated = true;
              } else {
                subjectRuleArray[a].isDirty = true
                scheduleConstraintObj.isScheduleUpdated = true;
              }
            } else {
              subjectObj.showSharedRoomsForSubjectString = rulesUtil.getSharedRoomsForSubjectString(rooms)
              if (scheduleConstraintObj.timeTableDetails !== null) {
                subjectObj.isDirty = true
              }
            }
          } else if (type === "elective") {
            if (rooms.length !== 0) {
              subjectObj.showSharedRoomsForSubjectString = rulesUtil.getSharedRoomsForSubjectString(rooms)
              if (scheduleConstraintObj.status === 'Completed') {
                subjectObj.isDirty = true
              }
              electiveToBeRemoved = false;
            }
          }
        }
      }
    }
    // using return only for the elective
    return electiveToBeRemoved
  }

  /**
   * takes modified room object and subjects array and replaces the object
   */
  replacingRoomObject = (modifiedRoomArray, subjectRuleArray, scheduleConstraintObj) => {
    for (let s = 0; s < subjectRuleArray.length; s++) {
      let subjectObj = subjectRuleArray[s]
      // Subjects has "ROOM" and Electives has "ROOMS" in schema.
      let rooms = subjectObj.room !== undefined ? subjectObj.room : subjectObj.rooms
      for (let r = 0; r < rooms.length; r++) {
        let roomObj = rooms[r]
        let roomObjPresent = lodashUtil.find(modifiedRoomArray, ["_id", roomObj.roomId]);
        if (roomObjPresent != undefined) {
          roomObj.name = roomObjPresent.name
          roomObj.roomCode = roomObjPresent.roomCode
          subjectObj.showSharedRoomsForSubjectString = rulesUtil.getSharedRoomsForSubjectString(rooms)
          if (scheduleConstraintObj.status === 'Completed') {
            subjectObj.isDirty = true
          }
          scheduleConstraintObj.isScheduleUpdated = true;
        }
      }
    }
  }
  componentWillUnmount = async () => {
    if (this.state.confirmDialogSharedRoom.isChanged) {
      await this.beforeUnload()
    }
  }

  undoChanges = () => {
    let confirmDialogSharedRoom = this.state.confirmDialogSharedRoom
    confirmDialogSharedRoom.isChanged = false
    this.setState({
      confirmDialogSharedRoom: confirmDialogSharedRoom
    })
  }
  beforeUnload = async () => {
    const i18n = this.props.i18n
    var flag = window.confirm(i18n.sharedRooms.msgForUnsavedChangesInTab);
    if (flag) {
      await this.onClickOfSave()
    }
    else {
      await this.undoChanges()
    }
  }
  render() {
    return (
      <SharedRoomComponent
        {...this.props}
        {...this.state}
        onClickOfSave={this.onClickOfSave}
        onClickOfAddNewSharedRoom={this.onClickOfAddNewSharedRoom}
        addNewSharedRoom={this.addNewSharedRoom}
        cancelAddNewSharedRoom={this.cancelAddNewSharedRoom}
        addRow={this.addRow}
        editRoom={this.editRoom}
        destructorOfWeeklyAvailabilitySchedule={this.destructorOfWeeklyAvailabilitySchedule}
        AddNewSharedRoom={this.AddNewSharedRoom}
        showContextualHelp={this.showContextualHelp}
        deletedRoomObject={this.deletedRoomObject}
        roomObjectChanged={this.roomObjectChanged}
      />
    )
  }
}

const mapDispatchToProps = dispatch => ({
  editSchoolInformation: (ownerId, schoolId, data) => dispatch(SchoolInformationActions.editSchoolInformation(ownerId, schoolId, data)),
  updatedSchoolMaster: (ownerId, schoolId, data) => dispatch(SchoolInformationActions.updatedSchoolMaster(ownerId, schoolId, data))
})

const mapStateToProps = (state, ownProps) => {
  return {
    activeSchool: state.schoolInformation.activeSchool,
    userInformation: state.userProfile.userInformation,
    updateSchoolinformationInProgress: state.schoolInformation.updateSchoolinformationInProgress
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withAppShell(SharedRoomContainer))
